var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCDstats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.475 8.53964V21.5017V8.53964ZM13.6344 13.4004V21.5017V13.4004ZM7.79376 18.2612V21.5017V18.2612ZM4.87344 27.9828H22.3954C23.1699 27.9828 23.9127 27.6414 24.4603 27.0337C25.008 26.4259 25.3157 25.6017 25.3157 24.7423V5.29912C25.3157 4.43968 25.008 3.61544 24.4603 3.00772C23.9127 2.40001 23.1699 2.05859 22.3954 2.05859H4.87344C4.09893 2.05859 3.35613 2.40001 2.80847 3.00772C2.2608 3.61544 1.95313 4.43968 1.95312 5.29912V24.7423C1.95313 25.6017 2.2608 26.4259 2.80847 27.0337C3.35613 27.6414 4.09893 27.9828 4.87344 27.9828Z",
    stroke: "#1DBF73",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDstats);
export default __webpack_public_path__ + "static/media/CDstats.8268e683988d95b9b35f0ebd8018dc85.svg";
export { ForwardRef as ReactComponent };